import { useEffect, useState } from 'react'
import { getUserList } from '../api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'

export const useGetUserListOnMount = (
  hideGuestUsers?: boolean,
  skip?: number,
  take?: number,
  orderBy?: string,
) => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(
          getUserList({
            hideGuestUsers: Boolean(hideGuestUsers),
            skip,
            take,
            orderBy,
          }),
        )

        if (mounted) {
          if (getUserList.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(`Error loading user list`)
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, hideGuestUsers, skip, take, orderBy])

  return status
}
